const youtubeSearchApi = "your_youtube_search_api_key";
export default youtubeSearchApi;
